export default __webpack_public_path__ + "static/media/uploader-trivia-3.294697d3.png";